import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { IconThumbDown, IconThumbUp, IconEdit } from '@tabler/icons-react';
import TimeAgo from "@/hooks/timesAge";


export default function UserType({message}){


    return(
        <>
        <div className="flex flex-col w-full m-4 ">
           
           <div className="flex flex-row justify-between ">
           <span className="text-md"><span className="font-bold">Nursid </span>replied with the following:</span>
           <span className="text-muted-foreground text-xs">{TimeAgo(message.timestamp)}</span>
           </div>
           <Card className="w-full p-4 mt-2">
               <span className="flex flex-col items-left justify-center h-full text-lg  text-justify text-muted-foreground">
               {message.text}
               </span>
           </Card>
           <div className="flex justify-between">

           <Button size="xs" variant="outline" className="border-none  hover:bg-gray-100 text-muted-foreground text-xs mt-1 "> <IconEdit size={16} className="me-2 mt-1"/> </Button>

           <div className="flex justify-end mt-1">
           <Button size="xs" variant="outline" className="border-none  hover:bg-gray-100 text-muted-foreground text-xs"> <IconThumbUp size={16} className="me-2 mt-1"/> Good</Button>

               <Button size="xs" variant="outline" className="border-none  hover:bg-gray-100 text-muted-foreground text-xs"> <IconThumbDown size={16} className="me-2 mt-1"/> Bad</Button>
           </div>
           </div>
       </div>
        </>
    )

}